import { generatePath } from "react-router-dom";
import { Authority } from "../features/Authorization/AuthProvider";
import { qstr } from "../features/Authorization/utils";

// "/segment1/:param/:optional?/*" // * - splat = whatever https://reactrouter.com/en/main/route/route
const getResetPassPath = (prefix) => `${prefix}/:email?/:token?/*`;

export const routes = {
  article: "/article/:articleId",
  assessment: "/assessment",
  checkEmail: "/check-email/:email",
  clients: "/clients",
  coaches: "/coaches",
  copyFeedbackForm: "/get-feedback/copy/:id",
  createFeedbackForm: "/get-feedback/create",
  dashboard: "/dashboard",
  editFeedbackForm: "/get-feedback/edit/:id",
  externalFeedbackPage: "/feedback/:formId?/:username?/:token?",
  feedbackResults: "/get-feedback/results/:id",
  forgotPassword: "/forgot-password/:email?",
  getFeedback: "/get-feedback",
  help: "/help",
  messages: "/messages",
  mySessions: "/my-sessions",
  myTeam: "/my-team",
  myValues: "/my-values",
  notes: "/notes",
  passwordChanged: "/password-changed",
  profile: "/profile",
  reports: "/reports",
  resetPassword_TODO_1_JAKUB_K: getResetPassPath("/api/public/reset-password"),
  resetPassword: getResetPassPath("/reset-password"),
  session: "/sessions/session",
  sessions: "/sessions",
  setPassword_TODO_1_JAKUB_K: getResetPassPath("/api/public/set-password"),
  setPassword: getResetPassPath("/set-password"),
  settings: "/settings",
  setValues: "/set-values",
  signIn: "/sign-in",
  signOut: "/sign-out",
  startSession: "/sessions/start-session",
  strengths: "/strengths",
  syncError: "/sync-error",
  syncSuccess: "/sync-success",
  team: "/team", // deprecated, use sessionsAndMembers
  sessionsAndMembers: "/sessions-and-members",
  hrPrograms: "/hr-programs",
  hrProgramDetail: "/hr-programs/:id",
  createProgram: "/create-program",
  createProgramEdit: "/create-program/:id",
};

export const parametrizedRoutes = {
  hrProgramDetail: ({ id }) => generatePath(routes.hrProgramDetail, { id }),
  createProgramEdit: ({ id }) => generatePath(routes.createProgramEdit, { id }),
  article: ({ articleId, displayPerex } = {}) =>
    qstr(
      generatePath(routes.article, { articleId }),
      displayPerex ? { displayPerex } : undefined,
    ),
  assessment: ({ returnTo } = {}) =>
    qstr(generatePath(routes.assessment), returnTo ? { returnTo } : undefined),
  checkEmail: ({ email } = {}) => generatePath(routes.checkEmail, { email }),
  copyFeedbackForm: ({ id }) => generatePath(routes.copyFeedbackForm, { id }),
  editFeedbackForm: ({ id }) => generatePath(routes.editFeedbackForm, { id }),
  feedbackResults: ({ id }) => generatePath(routes.feedbackResults, { id }),
  forgotPassword: ({ email } = {}) =>
    generatePath(routes.forgotPassword, { email }),
  settings: ({ tab } = {}) => `${routes.settings}?tab=${tab}`,
};

export const rolesDefByRoute = {
  [routes.sessionsAndMembers]: { anyOf: [Authority.HR] },
  [routes.team]: { anyOf: [Authority.HR] },
  [routes.reports]: { anyOf: [Authority.HR] },
  [routes.myTeam]: { anyOf: [Authority.MANAGER] },
  [routes.clients]: { anyOf: [Authority.COACH] },
  [routes.mySessions]: { noneOf: [Authority.COACH] },
  [routes.coaches]: { noneOf: [Authority.COACH] },
  [routes.profile]: { noneOf: [Authority.COACH] }, // there is separate CoachProfileSettings
  [routes.hrPrograms]: { anyOf: [Authority.HR] },
  [routes.hrProgramDetail]: { anyOf: [Authority.HR] },
  [routes.createProgram]: { anyOf: [Authority.HR] },
  [routes.createProgramEdit]: { anyOf: [Authority.HR] },
};
